module.exports = __webpack_public_path__ + "img/lilspoonfuls_logo.d7c608ad.svg";